import { Typography } from "@mui/material";
import { BorderHorizontal as BorderHorizontalIcon } from "@mui/icons-material"
import FormBuilderDesign from "components/InputsDesign/FormBuilderDesign";
import { DataFields } from "./DataFields";

export default function SeparatorModule({ 
  t,
  dataInstance, 
  register, 
  errors, 
  changeDataFunction, 
  changeColorGradient 
}) {

  return (<>
    <Typography variant="h6" sx={{ display: "flex", alignItems: "center" }}><BorderHorizontalIcon /> &nbsp; {t('designmenu_select_option_separators')}</Typography>
    <div style={{ background: dataInstance.separatorColor !== undefined ? dataInstance.separatorColor : "#ffffff", height: `${dataInstance.separatorSize}px`, marginBottom: 16 }}></div>    
    <FormBuilderDesign 
      dataDields={DataFields(t)}
      dataInstance={dataInstance}
      register={register}
      errors={errors}
      changeDataFunction={changeDataFunction}
      changeColorGradient={changeColorGradient}
    />
  </>)
}